import { render, staticRenderFns } from "./IndexRatePlans.vue?vue&type=template&id=59b8aaa7&scoped=true&"
import script from "./IndexRatePlans.vue?vue&type=script&lang=js&"
export * from "./IndexRatePlans.vue?vue&type=script&lang=js&"
import style0 from "./IndexRatePlans.vue?vue&type=style&index=0&id=59b8aaa7&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "59b8aaa7",
  null
  
)

export default component.exports